import { styled } from '@mui/material/styles';

export default styled('div')`
    color: ${({ color }) => (color ? color : '#fff')};
    font-size: 12px;
    padding: 5px;

    ${({ type }) => type === 'error' && `color: red;`};
`;
